import type { Stores } from '../../../entities/pool/public/stores';
import type { SellerTypeFilters } from '../../../entities/pool/public/seller_type_filters';
import type { ProductCardViewData } from '../../ProductList/type';
import type { BestCreatorRanking } from '@services/MarppleShop/features/CreatorRank/type/creator-rank.type.ts';

export interface IStoreRanking {
  /** 스토어 ID */
  store_id: number;

  /** 스코어 (점수) */
  score: number;

  /** 현재 순위 */
  current_rank: number;

  /** 이전 순위 (없을 경우 null) */
  previous_rank: number | null;
}

export interface PopularCreatorInfo {
  id: Stores['id'];
  domain_name: Stores['domain_name'];
  name: Stores['name'];
  logo_img: Stores['logo_img'];
  sns_url: Stores['sns_url'];
  thumbnail_img: Stores['thumbnail_img'];
  description: Stores['description'];
  is_adult: Stores['is_adult'];
  seller_type_name: SellerTypeFilters['name'];
  icon: SellerTypeFilters['icon'];
  no: SellerTypeFilters['no'];
}

export interface ICreatorRankingInfo extends PopularCreatorInfo, IStoreRanking {}

export interface ICreatorRanking extends ICreatorRankingInfo {
  products: ProductCardViewData[];
}

export type RankingPageType = 'realtime' | 'monthly' | 'weekly';

export type GetCreatorRankingsResponseType = {
  creator_rankings: ICreatorRanking[];
  updated_at: Date;
};

export type GetCreatorBestRankingResponseType = {
  data?: BestCreatorRanking;
};

export enum NewCreatorRankingType {
  MONTHLY = 'MONTHLY',
}
